import { pickBy, isObject } from '@/utils'
import AttrClass from './attr-member.vue'
import CompPickerLink from '../../comps/comp-pickerLink'

import VipSelest from './vip-select.vue'

export default {

  name: 'goodsGridTabVip',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '等級會員專享' },
    { label: '副標題', key: 'subtitle', component: 'input', value: 'SSVIP會員專享' },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    { label: '顯示價格', key: 'showPrice', component: 'switch', value: true },
    { label: '顯示品牌', key: 'brand', component: 'switch', value: true },
    {
      label: '商品分類',
      key: 'list',
      component: function (h, { key }) {
        return <AttrClass v-model={this.value[key]} />
      },
      value: [
        {
          tabTitle: '標籤',
          goodsList: [
            {
              imgUrl: '',
              linkPage: '',
              content: '',
              title: '商品名稱',
              id: '',
              price: 0,
              market_price: 0
            },
            {
              imgUrl: '',
              linkPage: '',
              content: '',
              title: '商品名稱',
              id: '',
              price: 0,
              market_price: 0
            },
            {
              imgUrl: '',
              linkPage: '',
              content: '',
              title: '商品名稱',
              id: '',
              price: 0,
              market_price: 0
            },
            {
              imgUrl: '',
              linkPage: '',
              content: '',
              title: '商品名稱',
              id: '',
              price: 0,
              market_price: 0
            }
          ]
        }
      ]
    },
		{
		  label: '選擇會員',
		  key: 'grade',
		  component: function (h, { key }) {
				let params = {
					api:this.$api.membercard.getGradeList,
					label:"grade_name",
					value:"grade_id",
					subTitle:"description"
				}
			return <VipSelest v-model={this.value[key]} params = {params} />
			},
		},
		{
		  label: '選擇付費會員',
		  key: 'vip_grade',
		  component: function (h, { key }) {
				let params = {
					api:this.$api.cardticket.listVipGrade,
					label:"grade_name",
					value:"vip_grade_id",
					subTitle:"description"
				}
			return <VipSelest v-model={this.value[key]} params = {params} />
			},
		},
		{
		  label: '會員標簽',
		  key: 'tagList',
		  component: function (h, { key }) {
				let params = {
					api:this.$api.member.getTagList,
					apiParams:{
						page: 1,
						pageSize: 500
					},
					key:"list",
					label:"tag_name",
					value:"tag_id",
				}
			return <VipSelest v-model={this.value[key]} params = {params} />
			},
		},
    {
      label: '檢視更多',
      key: 'moreLink',
      component: function (h, { key }) {
        return <CompPickerLink v-model={this.value[key]} style='margin-top: 7px;' />
      }
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data, list, distributor_id, grade, vip_grade, tagList} = v
    return {
      name,
      ...base,
      ...config,
      data,
      list,
			grade,
			vip_grade,
			tagList,
      distributor_id
    }
  },
  transformOut: (v) => {
    const obj = pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded',
          listIndex: 'listIndex'
        })
      },
      config: (v) => {
        return pickBy(v, {
          brand: 'brand',
          showPrice: 'showPrice',
          style: 'style',
          moreLink: 'moreLink'
        })
      },
			grade:'grade',
      vip_grade: 'vip_grade',
      tagList: 'tagList',
      list: 'list',
      data: 'data',
      distributor_id: 'distributor_id'
    })
    return obj
  }
}
